module.exports = __webpack_public_path__ + "img/twitterCloneProject.05d0c30f.jpeg";